export default function Badge({
  isLilac,
  text,
}: {
  isLilac: boolean;
  text: string;
}) {
  const variant = isLilac
    ? "bg-palette-lilac-400"
    : "text-palette-text-secondary border border-palette-grey-600";

  return (
    <div
      className={`w-fit text-center px-spacing-2 py-spacing-1 rounded-full details-ExtraSmall-Medium-Uppercase ${variant}`}
    >
      {text}
    </div>
  );
}
